import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex sm:items-center sm:justify-center min-h-screen sm:px-4 sm:pt-4 sm:pb-20 text-center" }
const _hoisted_2 = { class: "inline-block align-bottom sm:align-middle bg-white dark:bg-gray-800 sm:rounded-lg text-left overflow-hidden shadow-xl transform transition-all min-h-screen w-full fixed inset-x-0 top-0 sm:static sm:min-h-0 sm:max-w-4xl sm:w-full" }
const _hoisted_3 = { class: "bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 px-4 py-4 sm:px-6" }
const _hoisted_4 = { class: "text-lg leading-6 font-medium text-white" }
const _hoisted_5 = { class: "bg-white dark:bg-gray-800 px-3 pt-4 pb-3 sm:p-6 sm:pb-4 overflow-y-auto max-h-[calc(100vh-12rem)]" }
const _hoisted_6 = { class: "sm:flex sm:items-start" }
const _hoisted_7 = { class: "mt-3 text-left sm:mt-0 w-full" }
const _hoisted_8 = { class: "bg-gray-50 dark:bg-gray-700/30 p-4 sm:p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}
const _hoisted_12 = { class: "bg-gray-50 dark:bg-gray-700/30 p-4 sm:p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_14 = { class: "md:col-span-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "bg-gray-50 dark:bg-gray-700/30 p-4 sm:p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "error-message"
}
const _hoisted_20 = {
  key: 0,
  class: "error-message"
}
const _hoisted_21 = { class: "md:col-span-2" }
const _hoisted_22 = {
  key: 0,
  class: "error-message"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = ["type"]
const _hoisted_26 = {
  key: 0,
  class: "error-message"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = ["type"]
const _hoisted_30 = {
  key: 0,
  class: "error-message"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = ["type"]
const _hoisted_34 = {
  key: 0,
  class: "error-message"
}
const _hoisted_35 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_36 = { class: "bg-gray-50 dark:bg-gray-700/30 p-4 sm:p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_37 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_38 = ["value"]
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "bg-gray-50 dark:bg-gray-700/30 p-4 sm:p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_41 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_42 = ["value"]
const _hoisted_43 = ["value"]
const _hoisted_44 = ["value"]
const _hoisted_45 = ["value"]
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "bg-gray-50 dark:bg-gray-700/30 p-4 sm:p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_48 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_49 = { class: "md:col-span-2" }
const _hoisted_50 = ["value"]
const _hoisted_51 = ["value"]
const _hoisted_52 = ["value"]
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "bg-gray-50 dark:bg-gray-700/30 p-4 sm:p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_55 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_56 = ["value"]
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "md:col-span-2" }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "relative" }
const _hoisted_61 = ["type", "value"]
const _hoisted_62 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 flex flex-col gap-2 sm:px-6 sm:flex-row-reverse sm:gap-0" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 2 }

import { reactive, ref, watch } from 'vue'
import type { Employee, CreateEmployeeData, UpdateEmployeeData } from '@/services/employeeService'
import { Eye, EyeOff, Loader2 } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeModal',
  props: {
    isOpen: { type: Boolean },
    employee: {},
    editMode: { type: Boolean },
    validationErrors: {},
    existingEmployees: {},
    positions: {},
    loading: { type: Boolean }
  },
  emits: ["close", "save", "update", "edit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Form data for creating new employee
const formData = reactive<CreateEmployeeData & { password_confirmation?: string }>({
	first_name: '',
	last_name: '',
	username: '',
	email: '',
	password: '',
	password_confirmation: '',
	role: 'employee',
	status: 'active',
	position_id: '',
	phone: '',
	date_of_birth: '',
	gender: '',
	street: '',
	city: '',
	state: '',
	zipcode: ''
})

const showPassword = ref(false)
const showConfirmPassword = ref(false)
const showViewPassword = ref(false)

const isEditMode = ref(false)
const localValidationErrors = ref<Record<string, string>>({})

const fieldError = (field: string): string => {
	if (props.employee) return ''
	return localValidationErrors.value[field] || props.validationErrors?.[field] || ''
}

const clearLocalError = (field: string) => {
	if (localValidationErrors.value[field]) {
		delete localValidationErrors.value[field]
	}
}

// Populate form with employee data
const populateFormFromEmployee = (emp: Employee) => {
	formData.first_name = emp.first_name || ''
	formData.last_name = emp.last_name || ''
	formData.username = emp.username || ''
	formData.email = emp.email || ''
	formData.phone = emp.phone || ''
	formData.date_of_birth = emp.date_of_birth || ''
	formData.gender = emp.gender
	formData.street = emp.address || emp.street || ''
	formData.city = emp.city || ''
	formData.state = emp.state || ''
	formData.zipcode = emp.zipcode || ''
	formData.role = emp.role || 'employee'
	formData.status = emp.status || 'active'
	formData.position_id = emp.position_id
	// Don't populate password fields
	formData.password = ''
	formData.password_confirmation = ''
}

// Reset form to initial state
const resetForm = () => {
	formData.first_name = ''
	formData.last_name = ''
	formData.username = ''
	formData.email = ''
	formData.password = ''
	formData.password_confirmation = ''
	formData.role = 'employee'
	formData.status = 'active'
	formData.position_id = ''
	formData.phone = ''
	formData.date_of_birth = ''
	formData.gender = ''
	formData.street = ''
	formData.city = ''
	formData.state = ''
	formData.zipcode = ''
	localValidationErrors.value = {}
}

// Watch for modal open/close and editMode prop
watch(() => props.isOpen, (isOpen) => {
	if (isOpen) {
		if (props.editMode && props.employee) {
			isEditMode.value = true
			populateFormFromEmployee(props.employee)
		} else if (props.employee && !props.editMode) {
			isEditMode.value = false
		} else if (!props.employee) {
			isEditMode.value = false
			resetForm()
		}
	} else {
		isEditMode.value = false
		resetForm()
	}
}, { immediate: true })

// Watch for employee changes and populate form when editing
watch(() => props.employee, (newEmployee) => {
	if (newEmployee && isEditMode.value) {
		populateFormFromEmployee(newEmployee)
	} else if (!newEmployee) {
		resetForm()
		isEditMode.value = false
	}
}, { immediate: true })

// Watch for editMode prop changes
watch(() => props.editMode, (editMode) => {
	if (editMode && props.employee) {
		isEditMode.value = true
		populateFormFromEmployee(props.employee)
	} else if (!editMode && props.employee) {
		isEditMode.value = false
	}
})

// Start edit mode
const startEdit = () => {
	if (props.employee) {
		isEditMode.value = true
		populateFormFromEmployee(props.employee)
		emit('edit')
	}
}

// Handle close
const handleClose = () => {
	if (isEditMode.value) {
		isEditMode.value = false
		if (props.employee) {
			// Reset form but don't close modal - go back to view mode
			populateFormFromEmployee(props.employee)
		}
	} else {
		resetForm()
		emit('close')
	}
}

// Handle form submission
const handleSubmit = async () => {
	if (props.employee && isEditMode.value) {
		// Update mode
		const updateData: UpdateEmployeeData = {
			first_name: formData.first_name,
			last_name: formData.last_name,
			username: formData.username,
			email: formData.email,
			phone: formData.phone || undefined,
			date_of_birth: formData.date_of_birth || undefined,
			gender: formData.gender,
			address: formData.street || undefined,
			city: formData.city || undefined,
			state: formData.state || undefined,
			zipcode: formData.zipcode || undefined,
			position_id: formData.position_id
		}

		// Only include password if it's provided
		if (formData.password) {
			(updateData as any).password = formData.password
			if (formData.password_confirmation) {
				(updateData as any).password_confirmation = formData.password_confirmation
			}
		}

		emit('update', props.employee.id, updateData)
	} else if (!props.employee) {
		const errors: Record<string, string> = {}

		const firstName = (formData.first_name || '').trim()
		const lastName = (formData.last_name || '').trim()
		const username = (formData.username || '').trim()
		const email = (formData.email || '').trim()
		const password = formData.password || ''
		const passwordConfirmation = formData.password_confirmation || ''
		const positionId = formData.position_id

		if (!firstName) errors.first_name = 'First Name is required.'
		if (!lastName) errors.last_name = 'Last Name is required.'
		if (!username) errors.username = 'Username is required.'
		if (!email) errors.email = 'Email is required.'
		if (!password) errors.password = 'Password is required.'
		if (!positionId) errors.position_id = 'Position is required.'

		if (email) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			if (!emailRegex.test(email)) {
				errors.email = 'Please enter a valid email address.'
			}
		}

		if (password && password.length < 8) {
			errors.password = 'Password must be at least 8 characters long.'
		}

		if (password) {
			if (!passwordConfirmation) {
				errors.password_confirmation = 'Please confirm your password.'
			} else if (password !== passwordConfirmation) {
				errors.password_confirmation = 'Passwords do not match.'
			}
		}

		const existingEmployees = props.existingEmployees || []
		const normalizedUsername = username.toLowerCase()
		const normalizedEmail = email.toLowerCase()

		if (normalizedUsername && existingEmployees.some((item) => (item.username || '').toLowerCase() === normalizedUsername)) {
			errors.username = 'Username is already taken.'
		}

		if (normalizedEmail && existingEmployees.some((item) => (item.email || '').toLowerCase() === normalizedEmail)) {
			errors.email = 'Email is already taken.'
		}

		localValidationErrors.value = errors
		if (Object.keys(errors).length > 0) {
			localValidationErrors.value = errors
			return
		}

		emit('save', {
			...formData,
			first_name: firstName,
			last_name: lastName,
			username,
			email
		})
	}
}

const usStates = [
	'Alabama',
	'Alaska',
	'Arizona',
	'Arkansas',
	'California',
	'Colorado',
	'Connecticut',
	'Delaware',
	'Florida',
	'Georgia',
	'Hawaii',
	'Idaho',
	'Illinois',
	'Indiana',
	'Iowa',
	'Kansas',
	'Kentucky',
	'Louisiana',
	'Maine',
	'Maryland',
	'Massachusetts',
	'Michigan',
	'Minnesota',
	'Mississippi',
	'Missouri',
	'Montana',
	'Nebraska',
	'Nevada',
	'New Hampshire',
	'New Jersey',
	'New Mexico',
	'New York',
	'North Carolina',
	'North Dakota',
	'Ohio',
	'Oklahoma',
	'Oregon',
	'Pennsylvania',
	'Rhode Island',
	'South Carolina',
	'South Dakota',
	'Tennessee',
	'Texas',
	'Utah',
	'Vermont',
	'Virginia',
	'Washington',
	'West Virginia',
	'Wisconsin',
	'Wyoming',
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-50 overflow-y-auto",
            onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity bg-black bg-opacity-50 dark:bg-opacity-50",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(isEditMode.value ? 'Edit Employee' : __props.employee ? 'Employee Details' : 'Add New Employee'), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (!__props.employee || isEditMode.value)
                        ? (_openBlock(), _createElementBlock("form", {
                            key: 0,
                            onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                            class: "space-y-6"
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Personal Information", -1)),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", null, [
                                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "label" }, [
                                    _createTextVNode("First Name "),
                                    _createElementVNode("span", { class: "text-danger" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.first_name) = $event)),
                                    onInput: _cache[2] || (_cache[2] = ($event: any) => (clearLocalError('first_name'))),
                                    type: "text",
                                    class: "input w-full",
                                    placeholder: "Enter first name"
                                  }, null, 544), [
                                    [_vModelText, formData.first_name]
                                  ]),
                                  (!__props.employee && fieldError('first_name'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(fieldError('first_name')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "label" }, [
                                    _createTextVNode("Last Name "),
                                    _createElementVNode("span", { class: "text-danger" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.last_name) = $event)),
                                    onInput: _cache[4] || (_cache[4] = ($event: any) => (clearLocalError('last_name'))),
                                    type: "text",
                                    class: "input w-full",
                                    placeholder: "Enter last name"
                                  }, null, 544), [
                                    [_vModelText, formData.last_name]
                                  ]),
                                  (!__props.employee && fieldError('last_name'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(fieldError('last_name')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "label" }, "Date of Birth", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.date_of_birth) = $event)),
                                    type: "date",
                                    class: "input w-full",
                                    placeholder: "mm / dd / yyyy"
                                  }, null, 512), [
                                    [_vModelText, formData.date_of_birth]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[33] || (_cache[33] = _createElementVNode("label", { class: "label" }, "Gender", -1)),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.gender) = $event)),
                                    class: "input w-full"
                                  }, [...(_cache[32] || (_cache[32] = [
                                    _createElementVNode("option", {
                                      value: "",
                                      selected: ""
                                    }, "Select Gender", -1),
                                    _createElementVNode("option", { value: "male" }, "Male", -1),
                                    _createElementVNode("option", { value: "female" }, "Female", -1),
                                    _createElementVNode("option", { value: "other" }, "Other", -1)
                                  ]))], 512), [
                                    [_vModelSelect, formData.gender]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.phone) = $event)),
                                    type: "tel",
                                    class: "input w-full",
                                    placeholder: "Enter phone number"
                                  }, null, 512), [
                                    [_vModelText, formData.phone]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _cache[41] || (_cache[41] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Address", -1)),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "label" }, "Street", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.street) = $event)),
                                    type: "text",
                                    class: "input w-full",
                                    placeholder: "Enter street address"
                                  }, null, 512), [
                                    [_vModelText, formData.street]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "label" }, "City", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.city) = $event)),
                                    type: "text",
                                    class: "input w-full",
                                    placeholder: "Enter city"
                                  }, null, 512), [
                                    [_vModelText, formData.city]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label" }, "State", -1)),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.state) = $event)),
                                    class: "input w-full"
                                  }, [
                                    _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "Select a state", -1)),
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(usStates, (state) => {
                                      return _createElementVNode("option", {
                                        key: state,
                                        value: state
                                      }, _toDisplayString(state), 9, _hoisted_15)
                                    }), 64))
                                  ], 512), [
                                    [_vModelSelect, formData.state]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[40] || (_cache[40] = _createElementVNode("label", { class: "label" }, "Zipcode", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.zipcode) = $event)),
                                    type: "text",
                                    class: "input w-full",
                                    placeholder: "Enter zipcode"
                                  }, null, 512), [
                                    [_vModelText, formData.zipcode]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _cache[50] || (_cache[50] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Account Information", -1)),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", null, [
                                  _cache[43] || (_cache[43] = _createElementVNode("label", { class: "label" }, [
                                    _createTextVNode("Position "),
                                    _createElementVNode("span", { class: "text-danger" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.position_id) = $event)),
                                    onChange: _cache[13] || (_cache[13] = ($event: any) => (clearLocalError('position_id'))),
                                    class: "input w-full"
                                  }, [
                                    _cache[42] || (_cache[42] = _createElementVNode("option", {
                                      value: "",
                                      selected: ""
                                    }, "Select Position", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.positions, (pos) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: pos.id,
                                        value: pos.id
                                      }, _toDisplayString(pos.name), 9, _hoisted_18))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, formData.position_id]
                                  ]),
                                  (!__props.employee && fieldError('position_id'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(fieldError('position_id')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "label" }, [
                                    _createTextVNode("Email "),
                                    _createElementVNode("span", { class: "text-danger" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.email) = $event)),
                                    onInput: _cache[15] || (_cache[15] = ($event: any) => (clearLocalError('email'))),
                                    type: "email",
                                    class: "input w-full",
                                    placeholder: "Enter email address"
                                  }, null, 544), [
                                    [_vModelText, formData.email]
                                  ]),
                                  (!__props.employee && fieldError('email'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(fieldError('email')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "label" }, [
                                    _createTextVNode("Username "),
                                    _createElementVNode("span", { class: "text-danger" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.username) = $event)),
                                    onInput: _cache[17] || (_cache[17] = ($event: any) => {clearLocalError('username'); formData.username = $event.target.value.replace(/\s+/g, '')}),
                                    type: "text",
                                    class: "input w-full",
                                    placeholder: "Enter username"
                                  }, null, 544), [
                                    [_vModelText, formData.username]
                                  ]),
                                  (!__props.employee && fieldError('username'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(fieldError('username')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  (!isEditMode.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createElementVNode("div", null, [
                                          _cache[46] || (_cache[46] = _createElementVNode("label", { class: "label" }, [
                                            _createTextVNode("Password "),
                                            _createElementVNode("span", { class: "text-danger" }, "*")
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_24, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.password) = $event)),
                                              onInput: _cache[19] || (_cache[19] = ($event: any) => (clearLocalError('password'))),
                                              type: showPassword.value ? 'text' : 'password',
                                              placeholder: "Enter password (min. 8 characters)",
                                              class: "input w-full"
                                            }, null, 40, _hoisted_25), [
                                              [_vModelDynamic, formData.password]
                                            ]),
                                            _createElementVNode("button", {
                                              type: "button",
                                              onClick: _cache[20] || (_cache[20] = ($event: any) => (showPassword.value = !showPassword.value)),
                                              class: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                                            }, [
                                              (_openBlock(), _createBlock(_resolveDynamicComponent(showPassword.value ? _unref(EyeOff) : _unref(Eye)), { class: "h-5 w-5" }))
                                            ])
                                          ]),
                                          (!__props.employee && fieldError('password'))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(fieldError('password')), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _cache[47] || (_cache[47] = _createElementVNode("label", { class: "label" }, "Password", -1)),
                                        _createElementVNode("div", _hoisted_28, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.password) = $event)),
                                            onInput: _cache[22] || (_cache[22] = ($event: any) => (clearLocalError('password'))),
                                            type: showPassword.value ? 'text' : 'password',
                                            placeholder: "Leave blank to keep current password",
                                            class: "input w-full"
                                          }, null, 40, _hoisted_29), [
                                            [_vModelDynamic, formData.password]
                                          ]),
                                          _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[23] || (_cache[23] = ($event: any) => (showPassword.value = !showPassword.value)),
                                            class: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                                          }, [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(showPassword.value ? _unref(EyeOff) : _unref(Eye)), { class: "h-5 w-5" }))
                                          ])
                                        ]),
                                        (!__props.employee && fieldError('password'))
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(fieldError('password')), 1))
                                          : _createCommentVNode("", true),
                                        _cache[48] || (_cache[48] = _createElementVNode("p", { class: "text-xs text-secondary-text/60 dark:text-secondary-dark-text/60 mt-1" }, "Leave blank to keep the current password", -1))
                                      ]))
                                ]),
                                (formData.password)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _createElementVNode("div", null, [
                                        _cache[49] || (_cache[49] = _createElementVNode("label", { class: "label" }, [
                                          _createTextVNode("Confirm Password "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_32, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.password_confirmation) = $event)),
                                            onInput: _cache[25] || (_cache[25] = ($event: any) => (clearLocalError('password_confirmation'))),
                                            type: showConfirmPassword.value ? 'text' : 'password',
                                            placeholder: "Confirm password",
                                            class: "input w-full"
                                          }, null, 40, _hoisted_33), [
                                            [_vModelDynamic, formData.password_confirmation]
                                          ]),
                                          _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[26] || (_cache[26] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                                            class: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                                          }, [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(showConfirmPassword.value ? _unref(EyeOff) : _unref(Eye)), { class: "h-5 w-5" }))
                                          ])
                                        ]),
                                        (!__props.employee && fieldError('password_confirmation'))
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(fieldError('password_confirmation')), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 32))
                        : (__props.employee && !isEditMode.value)
                          ? (_openBlock(), _createElementBlock("form", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _cache[53] || (_cache[53] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Status & Meta", -1)),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", null, [
                                    _cache[51] || (_cache[51] = _createElementVNode("label", { class: "label" }, "Status", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.status ? __props.employee.status.charAt(0).toUpperCase() + __props.employee.status.slice(1) : '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_38)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[52] || (_cache[52] = _createElementVNode("label", { class: "label" }, "Date Created", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.created_at ? new Date(__props.employee.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'}) : '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_39)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _cache[59] || (_cache[59] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Personal Information", -1)),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", null, [
                                    _cache[54] || (_cache[54] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.first_name || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_42)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[55] || (_cache[55] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.last_name || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_43)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[56] || (_cache[56] = _createElementVNode("label", { class: "label" }, "Date of Birth", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.date_of_birth || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_44)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[57] || (_cache[57] = _createElementVNode("label", { class: "label" }, "Gender", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.gender ? __props.employee.gender.charAt(0).toUpperCase() + __props.employee.gender.slice(1) : '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_45)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[58] || (_cache[58] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.phone || '',
                                      type: "tel",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_46)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _cache[64] || (_cache[64] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Address", -1)),
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _cache[60] || (_cache[60] = _createElementVNode("label", { class: "label" }, "Street", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.street || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_50)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[61] || (_cache[61] = _createElementVNode("label", { class: "label" }, "City", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.city || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_51)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[62] || (_cache[62] = _createElementVNode("label", { class: "label" }, "State", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.state || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_52)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[63] || (_cache[63] = _createElementVNode("label", { class: "label" }, "Zipcode", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.zipcode || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_53)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _cache[70] || (_cache[70] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Account Information", -1)),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", null, [
                                    _cache[65] || (_cache[65] = _createElementVNode("label", { class: "label" }, "Position", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.position_id || __props.employee.position || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_56)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[66] || (_cache[66] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.email || '',
                                      type: "email",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_57)
                                  ]),
                                  _createElementVNode("div", _hoisted_58, [
                                    _cache[67] || (_cache[67] = _createElementVNode("label", { class: "label" }, "Username", -1)),
                                    _createElementVNode("input", {
                                      value: __props.employee.username || '',
                                      type: "text",
                                      class: "input w-full",
                                      disabled: ""
                                    }, null, 8, _hoisted_59)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[68] || (_cache[68] = _createElementVNode("label", { class: "label" }, "Password", -1)),
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("input", {
                                        type: showViewPassword.value ? 'text' : 'password',
                                        class: "input w-full",
                                        value: __props.employee.visible_password || '********',
                                        disabled: ""
                                      }, null, 8, _hoisted_61),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[27] || (_cache[27] = ($event: any) => (showViewPassword.value = !showViewPassword.value)),
                                        class: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                                      }, [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(showViewPassword.value ? _unref(EyeOff) : _unref(Eye)), { class: "h-5 w-5" }))
                                      ])
                                    ]),
                                    _cache[69] || (_cache[69] = _createElementVNode("p", { class: "text-xs text-secondary-text/60 dark:text-secondary-dark-text/60 mt-1" }, "Password provided to employee", -1))
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  (!__props.employee || isEditMode.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "submit",
                        onClick: handleSubmit,
                        disabled: __props.loading,
                        class: "btn btn-primary w-full sm:w-auto sm:ml-3 flex items-center justify-center"
                      }, [
                        (__props.loading)
                          ? (_openBlock(), _createBlock(_unref(Loader2), {
                              key: 0,
                              class: "w-4 h-4 mr-2 animate-spin"
                            }))
                          : _createCommentVNode("", true),
                        (__props.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(isEditMode.value ? 'Updating...' : 'Creating...'), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(isEditMode.value ? 'Update Employee' : 'Create Employee'), 1))
                      ], 8, _hoisted_63))
                    : _createCommentVNode("", true),
                  (__props.employee && !isEditMode.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        onClick: startEdit,
                        class: "btn btn-info w-full sm:w-auto sm:ml-3"
                      }, " Edit "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: handleClose,
                    class: "btn btn-secondary bg-danger hover:bg-slate-700 w-full sm:w-auto sm:ml-3"
                  }, _toDisplayString(isEditMode.value ? 'Cancel' : 'Close'), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})